import React, { FC, useMemo } from 'react';
import { concat, flatMap, minBy, maxBy } from 'lodash';
import { WorkPackageHeaderRowStyled, WPHeaderOuter } from './styled';
import { WorkPackageHeader } from '~/components/molecules/work-package-header-detail/work-package-header';
import {
  WorkPackageOwnerList,
  WorkPackagePrimaryOwnerList,
} from '~/components/molecules/work-package-header-detail/work-package-owner';
import { WorkPackage, Scalars } from '@bechtel/types';

interface WorkPackageDetailHeaderProps {
  showSecondaryOwners?: Scalars['Boolean'];
  workPackages: WorkPackage[];
  showRemainingTime?: Scalars['Boolean'];
  isPlanningModule?: Scalars['Boolean'];
}
export const WorkPackageDetailHeader: FC<WorkPackageDetailHeaderProps> = ({
  showSecondaryOwners,
  workPackages,
  showRemainingTime = false,
  isPlanningModule = false,
}) => {
  const secondaryOwners = workPackages && workPackages.length === 1 ? workPackages[0]?.secondaryOwners : [];
  const otherOwners = workPackages && workPackages.length === 1 ? workPackages[0]?.otherOwners : [];
  const workPackageTag = workPackages && workPackages.length === 1 ? workPackages[0]?.tag : '';
  const primaryOwners = useMemo(() => {
    return flatMap(workPackages, 'primaryOwners');
  }, [workPackages]);
  const minStartDate = useMemo(() => {
    return workPackages.length > 1
      ? minBy(workPackages, function (wp) {
          return wp.startDate;
        })?.startDate
      : workPackages[0]?.startDate;
  }, [workPackages]);

  const maxEndDate = useMemo(() => {
    return workPackages.length > 1
      ? maxBy(workPackages, function (wp) {
          return wp.endDate;
        })?.endDate
      : workPackages[0]?.endDate;
  }, [workPackages]);
  return (
    <WPHeaderOuter data-testid="work-package-detail-header">
      <WorkPackageOwnerList
        primaryOwners={primaryOwners}
        secondaryOwners={secondaryOwners ? secondaryOwners : []}
        otherOwners={otherOwners ? otherOwners : []}
        showSecondaryOwners={showSecondaryOwners}
        workPackage={workPackages[0]}
      />
      <WorkPackageHeaderRowStyled>
        <WorkPackageHeader
          isPlanningModule={isPlanningModule}
          workPackageTag={workPackageTag}
          startDate={minStartDate}
          endDate={maxEndDate}
          selectedWorkpackageList={workPackages}
          showRemainingTime={showRemainingTime}
          workOwners={concat(primaryOwners, secondaryOwners ? secondaryOwners : [], otherOwners ? otherOwners : [])}
        />
        {workPackages && workPackages.length > 0 && (
          <WorkPackagePrimaryOwnerList isPlanningModule={isPlanningModule} primaryOwners={primaryOwners} />
        )}
      </WorkPackageHeaderRowStyled>
    </WPHeaderOuter>
  );
};
